









































import { Component, Vue } from 'vue-property-decorator';
import TitleContainer from '@/components/common/TitleContainer.vue';
import UserStore, { UserStoreInterface } from '@/resource/user/user.store';
import ProfileLoading from '@/components/profile/ProfileLoading.vue';
import BeatLoader from 'vue-spinner/src/BeatLoader.vue';
import { validateNotEmpty } from '@/utils/form-validation';
import { MetaInfo } from 'vue-meta/types/vue-meta';
import { User } from '@/resource/user/user.model';
import seoDefault from '@/utils/seo-default';

interface ValidatePhoneNumber {
  number: { e164: string };
  isValid: boolean;
  country: string;
}

@Component({
  components: {
    TitleContainer,
    ProfileLoading,
    BeatLoader,
  },
  metaInfo(this: Profile): MetaInfo {
    return {
      title: 'Add Phone Number |',
      meta: [
        ...seoDefault({
          title: 'Add Phone Number | Mysoalan',
          description:
            'Adding your phone number to your profile would help us reach you whenever we want to share any good news, promotions, or get feedback from you.',
        }),
      ],
    };
  },
})
export default class Profile extends Vue {
  userStore: UserStoreInterface = UserStore;
  currentUser: User | null = null;
  isLoading = false;
  isSignOutLoading = false;

  mainTitle = [
    {
      type: 'normal',
      value: 'Add your',
    },
    {
      type: 'highlight',
      value: 'phone',
    },
    {
      type: 'normal',
      value: 'number',
    },
  ];

  mainP = `Adding your phone number to your profile would help us reach you whenever we want to share any good news, promotions, or get feedback from you.`;

  phoneNumInput = '';
  phoneNumInputError: string | boolean = false;
  phoneNumInputStatus: ValidatePhoneNumber | null = null;

  async created() {
    await this.userStore.fetchUser();
    this.currentUser = this.user;
  }

  get token(): string {
    return this.$route.params.token;
  }

  get user(): User | null {
    return this.userStore.user;
  }

  validatePhoneNumber(param: ValidatePhoneNumber) {
    this.phoneNumInputStatus = param;
  }

  async updatePhoneNumSubmitted() {
    if (this.isLoading) return;
    this.isLoading = true;

    if (this.validatePhoneNum()) {
      this.isLoading = false;
      return;
    }

    await this.userStore.addPhoneNumber({
      phoneNumber: this.phoneNumInput,
      token: this.token,
    });

    if (!this.userStore.error) {
      this.$toasted.global.mainToast({
        message: 'Added phone number successfully',
      });

      this.$router.push({
        path: '/',
      });
    } else {
      const error = 'Unable to add phone number';

      this.$toasted.global.mainToast({
        message: `ERROR: ${error}`,
      });
    }

    this.isLoading = false;
  }

  validatePhoneNum(): boolean {
    let hasError = false;

    if (!validateNotEmpty(this.phoneNumInput)) {
      this.phoneNumInputError = 'Phone number cannot empty';
      hasError = true;
    } else {
      this.phoneNumInputError = false;
    }

    if (this.phoneNumInputStatus) {
      if (!this.phoneNumInputStatus.isValid) {
        this.phoneNumInputError = `Phone number is not valid`;
        hasError = true;
      } else {
        this.phoneNumInputError = false;
        this.phoneNumInput = this.phoneNumInputStatus.number.e164;
      }
    }

    return hasError;
  }

  getTitle(title: string) {
    const separatedText = this.$lodash.startCase(title).toLowerCase();
    return this.$lodash.upperFirst(separatedText);
  }

  phoneNumberFixed =
    'bg-white-100 text-14 text-black-100 rounded py-14 px-14 w-full leading-normal';

  phoneNumberMain = `${this.phoneNumberFixed} border-gray-500 border-solid border-1`;
  phoneNumberError = `${this.phoneNumberFixed} bg-red-300 border-red-100 border-solid border-1`;
}
